<script>
	import { onMount } from "svelte";
    import { navigate } from "svelte-routing"

    onMount(async () => {
        navigate ("/");
	});
</script>